import { fetchUserEditProfile } from "../../../api/admin";
import { BoxInner } from "../../../style/contents/backup/backup";
import { UserProfile } from "../../../view/contents/user/user.list";

interface ModalProps {
  closedHandler: () => void;
  selectedUsers: UserProfile[]; // ✅ 단수 → 복수로 수정
  onDeleteSuccess: () => void; // ✅ 성공 후 호출할 콜백
}

const DeleteModal = ({
  selectedUsers,
  closedHandler,
  onDeleteSuccess,
}: ModalProps) => {
  const handleDelete = async () => {
    const adminUserId = localStorage.getItem("userId") ?? "";

    try {
      await Promise.all(
        selectedUsers.map(async (user) => {
          const responseData = {
            adminUserId,
            userId: user.userId,
            username: user.userName,
            userEmail: user.userEmail ?? "",
            phoneNumber: user.phoneNumber ?? "",
            jobPosition: user.jobPosition ?? "",
            department: user.department ?? "",
            permission: user.isAdmin
              ? "admin"
              : ("client" as "admin" | "client"),
            disable: true,
          };
          await fetchUserEditProfile(responseData);
        })
      );

      alert("선택한 사용자가 삭제 처리되었습니다.");
      onDeleteSuccess(); // ✅ 상위에서 목록 갱신 + 체크박스 초기화
      closedHandler();
    } catch (err) {
      console.error("삭제 실패:", err);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };
  return (
    <BoxInner>
      <div className="modal-header">
        <p>구성원 삭제</p>
        <button
          onClick={closedHandler}
          className="closed-modal-btn"
          style={{ cursor: "pointer" }}
        >
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <div className="del-contents-body">
        <p>다음 구성원을 삭제하시겠습니까?</p>
        <table>
          <tbody>
            {selectedUsers.map((user) => (
              <tr key={user.userId}>
                <th style={{ textAlign: "left", paddingRight: "10px" }}>
                  선택된 아이디
                </th>
                <td>{user.userAccount}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="btn-box">
          <button className="delete" onClick={handleDelete}>
            삭제
          </button>
          <button className="cancel" onClick={closedHandler}>
            취소
          </button>
        </div>
      </div>
    </BoxInner>
  );
};

export default DeleteModal;
